/**
 * Apply Cognito access token from POST /auth/exchange so /auth/me works when
 * HttpOnly session cookies are not sent cross-origin (SPA on dev-app → API on dev-api).
 */

export function applyExchangeAccessToken(api, exchangeData) {
  const at = exchangeData?.access_token;
  if (!at || typeof at !== 'string') return false;
  api.defaults.headers.common.Authorization = `Bearer ${at}`;
  try {
    sessionStorage.setItem('pv_bearer_token', at);
  } catch (_) {}
  return true;
}
